import { createFileRoute } from '@tanstack/react-router';

import { TendersPage } from '@/features/subcontracts/tenders-page';
import { PERSONAL_BIDDER } from '@/lib/api/subcontracts';

/** A sole trader's tenders: module 8's bidder screens for their own name. */
export const Route = createFileRoute('/_app/me/services/tenders/')({ component: PageRoute });

function PageRoute() {
  return <TendersPage orgId={PERSONAL_BIDDER} />;
}
